import { inject, Signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { NotificationService } from '@shared/services/notifications/notifications.service';
import { combineLatest, filter, map, Observable, of, take, tap, timeout } from 'rxjs';

const RESOLVE_TIMEOUT_MS = 15_000;
const NOTIFICATION_DURATION_MS = 10_000;

export function waitToResolveSignal(...signals: Signal<boolean>[]): Observable<boolean> {
  if (signals.length === 0) {
    return of(true);
  }

  const notificationService = inject(NotificationService);

  return combineLatest(signals.map(signal => toObservable(signal).pipe(filter(Boolean), take(1)))).pipe(
    map(() => true),
    timeout({
      first: RESOLVE_TIMEOUT_MS,
      with: () =>
        of(false).pipe(
          tap(() =>
            notificationService.showErrorNotification(
              'Loading is taking longer than usual. Some data may be missing until it finishes loading.',
              undefined,
              NOTIFICATION_DURATION_MS,
            ),
          ),
        ),
    }),
  );
}
